import { render } from "./register.vue?vue&type=template&id=7a96d9ca"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=7a96d9ca&lang=css"
script.render = render

export default script